
export default {
  locale: 'en',
  messages: {
    home: 'Home',
    sign_in: 'Sign in',
  },
};
